import React, { useState } from "react";


import { Button } from "./ui/Button";
import { Input } from "./ui/Input";
import { Label } from "./ui/Label";


import styled from "styled-components";
import ModalCenter from "@/common/components/modal/ModalCenter";

interface SimpleCertifycationModalProps {
  openCertifyPopup: boolean;
  setOpenCertifyPopup: (open: boolean) => void;
  handleCertify: (certifyData: any) => void;  
}

const SimpleCertifycationModal: React.FC<SimpleCertifycationModalProps> = ({ openCertifyPopup, setOpenCertifyPopup, handleCertify }) => {

  const [certifyData, setCertifyData] = useState<{ name: string, phone: string }>({ name: '', phone: '' });

  return (
    <ModalCenter
      isOpen={openCertifyPopup} 
      onClose={() => setOpenCertifyPopup(false)} 
      title="간편 인증"
      footer={
        <Button 
          $variant='default' 
          onClick={() => {
            handleCertify(certifyData);
          }}
        >
          인증하기
        </Button>
      }
    >
      <CertifyContent>
        <InputGroup>
          <Label>이름</Label>
          <Input
            type="text"
            value={certifyData.name}
            onChange={(e) => setCertifyData((prev:any) => ({...prev, name: e.target.value}))}
            placeholder="이름을 입력해주세요"
          />
        </InputGroup>
        <InputGroup>
          <Label>휴대폰 번호</Label>
          <Input
            type="text"
            value={certifyData.phone}
            onChange={(e) => setCertifyData((prev:any) => ({...prev, phone: e.target.value}))}
            placeholder="휴대폰 번호를 입력해주세요"
          />
        </InputGroup>
      </CertifyContent>
    </ModalCenter>)
}


const CertifyContent = styled.div`
  padding: 24px;
  width : 320px;
`;

const InputGroup = styled.div`
  margin-bottom: 16px;
`;

export default SimpleCertifycationModal;

